import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Input, Output } from '@angular/core';

import { AppSharedModule } from 'app/app-shared.module';
import {
  EnableClassTelemetry,
  EnableComponentTelemetry,
  injectComponentTelemetryService,
} from 'app/services/otel.service';

@EnableClassTelemetry()
@Component({
  selector: 'app-point-popout',
  imports: [AppSharedModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './point-popout.component.html',
  styleUrl: './point-popout.component.scss',
})
export class PointPopoutComponent {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();

  @Input() isDashboardLocked!: boolean;

  @Output() smartSummary = new EventEmitter<void>();

  onSmartSummary(): void {
    this.smartSummary.emit();
  }
}
